import React from "react";
import { createPortal } from "react-dom";
import { Loader2, X } from "lucide-react";

const BondPlayConfirmModal = ({
  open = false,
  eyebrow = "Confirm",
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Go back",
  tone = "primary",
  loading = false,
  loadingLabel,
  confirmDisabled = false,
  onClose,
  onCancel,
  onConfirm,
}) => {
  const handleCancel = onCancel || onClose;
  if (!open) return null;

  const busyLabel = loadingLabel || `${confirmLabel}…`;

  return createPortal(
    <div className="bplay-confirm-root" role="dialog" aria-modal="true" aria-labelledby="bplay-confirm-title">
      <button
        type="button"
        className="bplay-confirm-backdrop"
        aria-label="Close"
        disabled={loading}
        onClick={onClose}
      />
      <div className="bplay-confirm-sheet">
        <header className="bplay-confirm-head">
          <div className="bplay-confirm-head-main">
            <p className="bplay-confirm-eyebrow">{eyebrow}</p>
            <h2 id="bplay-confirm-title" className="bplay-confirm-title">
              {title}
            </h2>
          </div>
          <button
            type="button"
            className="bplay-confirm-close"
            aria-label="Close"
            disabled={loading}
            onClick={onClose}
          >
            <X size={16} strokeWidth={2.25} />
          </button>
        </header>

        {description ? <div className="bplay-confirm-body">{description}</div> : null}

        <footer className="bplay-confirm-foot">
          <button
            type="button"
            className="bplay-confirm-btn bplay-confirm-btn-ghost"
            disabled={loading}
            onClick={handleCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`bplay-confirm-btn bplay-confirm-btn-${tone}`}
            disabled={loading || confirmDisabled}
            onClick={onConfirm}
          >
            {loading ? (
              <>
                <Loader2 size={15} className="bplay-spin" />
                <span>{busyLabel}</span>
              </>
            ) : (
              confirmLabel
            )}
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
};

export default BondPlayConfirmModal;
